import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { List, ListItem } from 'chaoskit/src/components';
import { Highlight, connectMenu } from 'react-instantsearch-dom';

import TutorialTeaser, {
  getTutorialCategory,
} from '../community/tutorials/TutorialTeaser';
import useAuthor, { getAuthor } from '../../hooks/useAuthor';

const CategoryMenu = ({ items, refine, createURL }) => (
  <List type={['space']}>
    {items.length > 0 ? (
      items.map(item => {
        const categoryMeta = getTutorialCategory([item.label]);

        return (
          <ListItem key={item.value}>
            <a
              href={createURL(item.value)}
              onClick={event => {
                event.preventDefault();
                refine(item.value);
              }}
              className={cx('search__category-menuItem', {
                'is-active': item.isRefined,
              })}
            >
              <div className="search__category-menuItem-iconWrapper">
                <img src={categoryMeta.icon} alt={item.label} />
              </div>
              <div>
                <div className="u-textHeading u-textDefault u-textSmall">
                  {item.label}
                </div>
                <div className="u-textXsmall u-textMuted">
                  {item.count} article{item.count > 1 && 's'}
                </div>
              </div>
            </a>
          </ListItem>
        );
      })
    ) : (
      <p className="u-textSmall u-textMuted">No matching authors</p>
    )}
  </List>
);

CategoryMenu.propTypes = {
  items: PropTypes.array,
  refine: PropTypes.func,
  createURL: PropTypes.func,
};

export const CustomCategoryMenu = connectMenu(CategoryMenu);

const AuthorMenu = ({ items, refine, createURL }) => {
  const authors = useAuthor();

  return (
    <List type={['space']}>
      {items.length > 0 ? (
        items.map(item => {
          const authorMetadata = getAuthor(authors, item.label);

          return (
            <ListItem key={item.value}>
              <a
                href={createURL(item.value)}
                onClick={event => {
                  event.preventDefault();
                  refine(item.value);
                }}
                className={cx('search__author-menuItem', {
                  'is-active': item.isRefined,
                })}
              >
                <img src={authorMetadata.frontmatter.photo} alt="" />
                <div>
                  <div className="u-textHeading u-textDefault u-textSmall">
                    {item.label}
                  </div>
                  <div className="u-textXsmall u-textMuted">
                    {item.count} article{item.count > 1 && 's'}
                  </div>
                </div>
              </a>
            </ListItem>
          );
        })
      ) : (
        <p className="u-textSmall u-textMuted">No matching authors</p>
      )}
    </List>
  );
};

AuthorMenu.propTypes = {
  items: PropTypes.array,
  refine: PropTypes.func,
  createURL: PropTypes.func,
};

export const CustomAuthorMenu = connectMenu(AuthorMenu);

export const Hit = ({ hit }) => (
  <TutorialTeaser
    link={`${hit.slug}${hit.contentId ? `#${hit.contentId}` : ''}`}
    title={<Highlight tagName="mark" attribute="title" hit={hit} />}
    author={hit.author}
    excerpt={<Highlight tagName="mark" attribute="excerpt" hit={hit} />}
    categories={hit.categories}
  />
);

Hit.propTypes = {
  hit: PropTypes.object,
};
